export const sequence = {
    sequence_empty_list: 'There is no questionnaires available for this time period.',
    sequence_list_summary_one: '{{count}} questionnaire to fill in',
    sequence_list_summary_other: '{{count}} questionnaires to fill in',
    sequence_empty_title: 'All caught up',
    sequence_empty_text: 'No questionnaire to fill in right now.',
    sequence_next_label: 'Next:',
};
